<div class="print-full-height relative flex h-full w-full flex-col bg-white">
  <!-- pr-24 makes sure not to overlap the modal buttons -->
  <div class="mt-2 flex items-center justify-between py-4 pl-5 pr-24 lg:pl-8 print:hidden">
    <button (click)="goBack()" class="max-w-full cursor-pointer truncate whitespace-nowrap text-left text-blue-500 hover:underline">
      ← {{ 'global.backToOverview' | transloco }}
    </button>
  </div>

  <!-- <app-scroll-container class="flex-1"> -->
  <div class="flex-1 px-4 py-1 lg:px-8 lg:py-4">
    @if (documentParameters?.type === 'mbDocument' || documentParameters?.provider === 'mercedes') {
      <app-mercedes-articles [documentParameters]="documentParameters" />
    } @else if (documentParameters?.type === 'hgsErrorCode' || documentParameters?.provider === 'hgs') {
      <app-hgs-articles [documentParameters]="documentParameters" />
    } @else if (
      documentParameters?.type === 'slp' ||
      documentParameters?.provider === 'volkswagen' ||
      documentParameters?.provider === 'skoda' ||
      documentParameters?.provider === 'seat' ||
      documentParameters?.provider === 'audi'
    ) {
      <app-vw-articles [documentParameters]="documentParameters" />
    } @else if (documentParameters?.type === 'tesla' || documentParameters?.provider === 'tesla') {
      <app-tesla-articles [documentParameters]="documentParameters" />
    } @else {
      <app-hp-articles [documentParameters]="documentParameters" />
    }
  </div>
  <!-- </app-scroll-container> -->
</div>
